import ResourcesSection from './ResourcesSection';

export default ResourcesSection;
